import { post, get, request } from "./http.js";
// 到底部及公共配置数据
const indexGetconfig = (data) => post("index/getconfig", data);
// 首页
const indexIndex = (data) => post("index/index", data);
// 得到所有栏目数据
const indexGetallcate = (data) => post("index/getallcate", data);
// 得到某个单页面类型的菜单数据
const indexGetonedata = (data) => post("index/getonedata", data);
// 根据一级菜单获取当前菜单信息及所有子级菜单信息
const indexGetpiddata = (data) => post("index/getpiddata", data);
// 得到企业风采
const indexFengcai = (data) => post("index/fengcai", data);
// 得到荣誉资质
const indexHonor = (data) => post("index/honor", data);
// 发展历程
const indexHistory = (data) => post("index/history", data);
// 产品列表
const indexProductlist = (data) => post("index/productlist", data);
// 产品详情
const indexProductdetail = (data) => post("index/productdetail", data);
// 应用方向
const indexApps = (data) => post("index/apps", data);
// 新闻列表
const indexNewslist = (data) => post("index/newslist", data);
// 新闻详情
const indexNewsdetail = (data) => post("index/newsdetail", data);
// 在线留言
const indexMessage = (data) => post("index/message", data);
// 获取总部及各办事处信息
const indexGetcompany = (data) => post("index/getcompany", data);
// 人才招聘
const indexRecruit = (data) => post("index/recruit", data);
// 获取定制产品需求表链接
const indexGetwangpan = (data) => post("index/getwangpan", data);
// 得到招聘理念 福利待遇
const indexGetrecruitconfig = (data) => post("index/getrecruitconfig", data);
// 文章专栏列表
const indexArticlelist = (data) => post("index/articlelist", data);
// 文章专栏详情
const indexArticledetail = (data) => post("index/articledetail", data);

export default {
    indexArticlelist,
    indexArticledetail,
    indexGetconfig,
    indexIndex,
    indexGetallcate,
    indexGetonedata,
    indexGetpiddata,
    indexFengcai,
    indexHonor,
    indexHistory,
    indexProductlist,
    indexProductdetail,
    indexApps,
    indexNewslist,
    indexNewsdetail,
    indexMessage,
    indexGetcompany,
    indexRecruit,
    indexGetwangpan,
    indexGetrecruitconfig,
}